<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="card p-5">
        <form-group label="Select Partner">
          <b-skeleton type="input" v-show="loading"></b-skeleton>
          <v-select
            label="name"
            :options="partners"
            v-show="!loading"
            v-model="selectedPartner"
          >
            <template slot="option" slot-scope="p">
              <div>
                {{ p.name }} - {{ p.contact_number }}<br />
                {{ p.email_address }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="p">
              {{ p.name }} -
              <small
                v-if="p.is_shipping_required == 1"
                class="text-muted font-italic"
                >Partner requires shipping</small
              >
            </template>
          </v-select>
          <small v-if="$v.selectedPartner.$error" class="text-danger">
            Please select partner
          </small>
        </form-group>

        <!-- Shipping required -->
        <form-group label="Shipping Required">
          <b-form-radio
            v-model="booking.is_shipping_required"
            name="jobRequiresShipping"
            value="1"
            >Yes collection to be arranged</b-form-radio
          >
          <b-form-radio
            v-model="booking.is_shipping_required"
            name="jobRequiresShipping"
            value="0"
            >No, Devices are here</b-form-radio
          >
        </form-group>

        <form-group
          label="Scheme"
          :required="true"
          v-if="selectedPartner && selectedPartner.is_insurance_jobs"
        >
          <v-select
            @blur="$v.booking.scheme_id.$touch"
            :class="{ 'is-invalid': $v.booking.scheme_id.$error }"
            label="scheme"
            :reduce="(scheme) => scheme.id"
            :options="selectedPartner.schemes"
            v-show="!loading"
            v-model="booking.scheme_id"
          >
            <template slot="option" slot-scope="s">
              <div>
                {{ s.name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="s">
              {{ s.name }}
              <small v-if="s.full_cover == 1" class="text-muted font-italic">
                - Full Cover</small
              >
            </template>
          </v-select>

          <small v-if="$v.booking.scheme_id.$error" class="text-danger">
            Please select scheme
          </small>
        </form-group>

        <form-group label="File">
          <small>csv,xls or xlsx file</small><br>
          <small class="text-danger">Row 1 should contain column headings exactly as specified below</small>
              <file-upload
                @files-uploaded="
                  selectedFile = $event;
                  fileUploading = false;
                "
                @files-uploaded-started="fileUploading = true"
                :multiple="false"
                accepted-types=".xlsx,.csv"
              />
               
            </form-group>
           

        <b-button variant="primary" @click="handleSubmit" v-if="!loading"> Upload </b-button>
        <b-spinner label="Spinning" v-if="loading"></b-spinner>



        <table class="table table-sm border mt-5">
          <tr class="bg-dark text-white">
            <td>COLUMN</td>
            <td>HEADING</td>
            <td>NOTES</td>
          </tr>
          <tr>
            <td>A</td>
            <td>policy_number</td>
            <td></td>
          </tr>
          <tr>
            <td>B</td>
            <td>claim_number</td>
            <td></td>
          </tr>
          <tr>
            <td>C</td>
            <td>spm_number</td>
            <td></td>
          </tr>
          <tr>
            <td>D</td>
            <td>excess_payable</td>
            <td>(1 = yes , 0 = no)</td>
          </tr>
          <tr>
            <td>E</td>
            <td>excess_calculation_type</td>
            <td>(amount or percentage)</td>
          </tr>
          <tr>
            <td>F</td>
            <td>excess_amount</td>
            <td></td>
          </tr>
          <tr>
            <td>G</td>
            <td>excess_percentage</td>
            <td></td>
          </tr>
          <tr>
            <td>H</td>
            <td>replacement_price</td>
            <td></td>
          </tr>
          <tr>
            <td>I</td>
            <td>symptoms_description</td>
            <td></td>
          </tr>
          <tr>
            <td>J</td>
            <td>condition_description</td>
            <td></td>
          </tr>
          <tr>
            <td>K</td>
            <td>imei</td>
            <td></td>
          </tr>
          <tr>
            <td>L</td>
            <td>serial</td>
            <td></td>
          </tr>
          <tr>
            <td>M</td>
            <td>is_in_warranty</td>
            <td>(1 = yes , 0 = no)</td>
          </tr>
          <tr>
            <td>N</td>
            <td>pop_supplier</td>
            <td></td>
          </tr>
          
          <tr>
            <td>O</td>
            <td>pop_date</td>
            <td>2020-12-04 14:34:20</td>
          </tr>
           <tr>
            <td>P</td>
            <td>client_reference</td>
             <td></td>
          </tr>
           <tr>
            <td>Q</td>
            <td>manufacture_reference</td>
             <td></td>
          </tr>
            <tr>
            <td>R</td>
            <td>job_reference</td>
             <td></td>
          </tr>
          <tr>
            <td>S</td>
            <td>secondary_reference</td>
            <td></td>
          </tr>
          <tr>
            <td>T</td>
            <td>manufacture_id</td>
            <td>
              <table class="table-sm">
                <tr class="bg-light">
                 <td>ID</td> 
                 <td>Name</td>
                </tr>
                <tr v-for="m in manufactures" :key="m.id">
                  <td>{{ m.id }}</td>
                  <td>{{ m.description }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>U</td>
            <td>device_type_id</td>
            <td>
               <table class="table-sm">
                <tr class="bg-light">
                 <td>ID</td> 
                 <td>Name</td>
                </tr>
                <tr v-for="m in deviceTypes" :key="m.id">
                  <td>{{ m.id }}</td>
                  <td>{{ m.description }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>V</td>
            <td>model</td>
            <td></td>
          </tr>
         
          <tr>
            <td>W</td>
            <td>pass_code</td>
            <td></td>
          </tr>
           <tr>
            <td>X</td>
            <td>pattern_sequence</td>
            <td></td>
          </tr>
           <tr>
            <td>Y</td>
            <td>client_name</td>
            <td></td>
          </tr>
           <tr>
            <td>Z</td>
            <td>client_surname</td>
            <td></td>
          </tr>
            <tr>
            <td>AA</td>
            <td>client_contact_number</td>
            <td></td>
          </tr>
            <tr>
            <td>AB</td>
            <td>client_email_address</td>
            <td></td>
          </tr>
            <tr>
            <td>AC</td>
            <td>client_address</td>
            <td></td>
          </tr>
            <tr>
            <td>AD</td>
            <td>client_city</td>
            <td></td>
          </tr>
            <tr>
            <td>AE</td>
            <td>client_postal_code</td>
            <td></td>
          </tr>
            <tr>
            <td>AF</td>
            <td>client_province_id</td>
            <td>
                <table class="table-sm">
                <tr class="bg-light">
                 <td>ID</td> 
                 <td>Name</td>
                </tr>
                <tr v-for="m in provinces" :key="m.id">
                  <td>{{ m.id }}</td>
                  <td>{{ m.province }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import { required, requiredIf } from "vuelidate/lib/validators";
import formGroup from "@/components/common/FormGroup";
import fileUpload from "@/components/common/FileUpload";

export default {
  components: {
    formGroup,
    fileUpload
  },
  computed: {},
  mounted() {
    this.getPartners();
    this.getData();
  },
  data() {
    return {
      partners:[],
      selectedFile:[],
      fileUploading: false,
      manufactures:[],
      deviceTypes:[],
      provinces:[],
      selectedPartner: null,

      booking: {
        is_insurance_job: 0,
        is_shipping_required: 0,
      },

      errors: null,
      submitStatus: null,
      loading: false,
    };
  },

  validations: {
    selectedPartner: {
      required,
    },

    booking: {
      is_shipping_required: {
        required,
      },
      scheme_id: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },
    },
  },

  methods: {
    async getPartners() {
      try {
        this.loading = true;
        let { data } = await jobRepo.getPartners();
        this.partners = data.partners;
        
      } finally {
        this.loading = false;
      }
    },
    async getData() {
      try {
        this.loading = true;
        let { data } = await jobRepo.booking();
        this.manufactures = data.manufactures;
        this.deviceTypes = data.device_types;
        this.provinces = data.provinces;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

     async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();

    

      if (this.$v.$invalid || this.fileUploading) {
        
        if (this.fileUploading) alert("file uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {

        if(this.selectedFile.length==0){
           this.loading = false;
           this.submitStatus = null;
          return alert("Please upload file");
        }

        try {
          this.booking.file_id = this.selectedFile;
          this.booking.partner_id = this.selectedPartner.id
          await jobRepo.bulkBooking(this.booking);

           this.$root.$bvToast.toast("Success", {
              title: "Uploaded Successfully",
              autoHideDelay: 3000,
              variant: "success",
            });

            this.booking =   {
              is_insurance_job: 0,
              is_shipping_required: 0,
            }

            this.selectedPartner = null;

            this.selectedFile = [];
         
        } catch (error) {
          console.log(error);
            this.$root.$bvToast.toast(error.message, {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

  },

  watch: {
    selectedPartner: {
      immediate: true,
      handler: function (newVal) {
        if (newVal != null) {
          if (this.selectedPartner.is_shipping_required == 1) {
            this.booking.is_shipping_required = 1;
          } else {
            this.booking.is_shipping_required = 0;
          }
          if (this.selectedPartner.is_insurance_jobs == 1) {
            this.booking.is_insurance_job = 1;
          } else {
            this.booking.is_insurance_job = 0;
          }
        }
      },
    },
  },
};
</script>


